import * as React from 'react';
type Props = {
  className?: string;
};
export function IllustrationDietary({ className }: Props) {
  return (
    <svg
      viewBox="0 0 114 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-IllustrationDietary"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.057 64.647C55.7944 33.1566 93.2329 -17.722 44.7564 7.76337C-30.6823 47.4235 11.2589 79.4457 25.0032 92.0714C50.7162 115.692 146.319 96.1374 101.057 64.647Z"
        fill="#D6E4EE"
      />
      <path
        d="M58.4733 9.7002C34.8494 9.7002 15.6992 28.8521 15.6992 52.4761C15.6992 76.1001 34.8511 95.2502 58.4751 95.2502C82.0991 95.2502 101.249 76.0983 101.249 52.4743C101.222 28.8613 82.0863 9.72619 58.4733 9.7002Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M58.9203 88.0393C78.3151 88.0393 94.0378 72.3166 94.0378 52.9217C94.0378 33.5269 78.3151 17.8042 58.9203 17.8042C39.5254 17.8042 23.8027 33.5269 23.8027 52.9217C23.8027 72.3166 39.5254 88.0393 58.9203 88.0393Z"
        stroke="currentColor"
      />
      <path
        d="M82.6328 38.2006L72.127 48.7064C71.072 49.7613 69.3616 49.7613 68.3067 48.7064L64.4864 44.8861C63.4315 43.8312 63.4315 42.1208 64.4864 41.0658L74.9922 30.5601M66.3966 46.7963L41.7286 71.4642M80.0063 35.5742L71.4107 44.1698M77.6186 33.1865L69.023 41.7821"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.5149 35.5218C37.3997 37.6266 38.3546 42.0114 41.6447 45.3141C44.9364 48.6152 49.3171 49.5879 51.4306 47.4814C53.5457 45.3765 52.5924 40.9901 49.3008 37.689C46.009 34.3879 41.6283 33.4152 39.5149 35.5218ZM75.6327 71.6616L51.4423 47.4711L75.6327 71.6616Z"
        stroke="currentColor"
      />
    </svg>
  );
}
